import { CommonModule } from '@angular/common'
import { Component, Input, OnInit, inject } from '@angular/core'
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser'
import { Router, RouterModule } from '@angular/router'
import { map, Observable } from 'rxjs'

import {
  CollectionRecord,
  Enums,
  HuntPackageRecord,
  ThreatProfile,
} from '@cyborg-monorepo/hunter/common'
import {
  BadgeComponent,
  LinkComponent,
  MarkdownComponent,
  TypographyComponent,
} from '@hyperkit'

import { gatherTags } from '../../../../helpers/utils'
import { CollectionService } from '../../../research/services/collection.service'
import { SearchStateService } from '../../../research/services/search-state.service'
import {
  CyborgRouterSearchLink,
  SearchUrlService,
} from '../../../research/services/search-url.service'
import { ThreatProfileService } from '../../services/threat-profile.service'
import {
  FacetButtonItem,
  FacetButtonsComponent,
} from '../facet-buttons/facet-buttons.component'

@Component({
  standalone: true,
  selector: 'cyborg-hunt-package-overview',
  imports: [
    CommonModule,
    RouterModule,
    BadgeComponent,
    LinkComponent,
    MarkdownComponent,
    TypographyComponent,
    FacetButtonsComponent,
  ],
  templateUrl: './hunt-package-overview.component.html',
  styleUrls: ['./hunt-package-overview.component.scss'],
})
export class HuntPackageOverviewComponent implements OnInit {
  private threatProfileService = inject(ThreatProfileService)
  private sanitizer = inject(DomSanitizer)
  private collectionService = inject(CollectionService)
  searchStateService = inject(SearchStateService)
  private searchUrlService = inject(SearchUrlService)
  private router = inject(Router)

  @Input() public data: HuntPackageRecord
  public tags: FacetButtonItem[]
  public threatProfiles$: Observable<Array<ThreatProfile>>
  public relatedCollections$: Observable<Array<CollectionRecord>>

  public searchLink: Observable<CyborgRouterSearchLink>

  public deepDive: SafeResourceUrl

  public ngOnInit(): void {
    this.getDetails()
    this.getRelatedCollections()
  }

  private getDetails(): void {
    if (this.data?.context?.threat_names?.length > 0) {
      this.getThreatProfile(this.data)
    }
    this.tags = gatherTags(this.data)

    if (this.data?.references?.deep_dives?.length > 0) {
      const regexp = /\?v=(?<videoId>.*)/
      const deepDiveFormated =
        this.data.references.deep_dives[0].match(regexp).groups.videoId
      this.deepDive = this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://www.youtube.com/embed/${deepDiveFormated}`,
      )
    }
  }

  private getThreatProfile(huntPackage: HuntPackageRecord): void {
    this.threatProfiles$ =
      this.threatProfileService.getThreatProfilebyThreatName(huntPackage)
  }

  private getRelatedCollections(): void {
    this.relatedCollections$ =
      this.collectionService.getRelatedCollectionsByHuntPackageUUID(
        this.data.UUID,
      )
  }

  public navigateToCollection(collection: string): void {
    this.searchStateService.reset()
    this.searchStateService.setLibrary(
      [Enums.CyborgIndexEnum.CYBORG_COLLECTIONS],
      true,
    )
    this.searchStateService.setTerm(collection)

    const searchLink: CyborgRouterSearchLink =
      this.searchUrlService.stateToRouterLink(
        this.searchStateService.state.getValue(),
      )
    this.searchLink = this.searchStateService.state.pipe(
      map((state) => this.searchUrlService.stateToRouterLink(state)),
    )

    this.router.navigate(searchLink.routerLink as string[], {
      queryParams: searchLink.queryParams,
    })
  }
}
